import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";
import { useTranslation } from "react-i18next";

export const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label={t("action.scrollTop", { defaultValue: "Scroll to top" })}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-5 start-5 z-40 grid h-11 w-11 place-items-center rounded-full border border-primary/30 bg-card text-foreground shadow-soft transition-all duration-300 hover:scale-110 hover:border-primary ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-2 pointer-events-none"
      }`}
    >
      <ChevronUp className="h-5 w-5" />
    </button>
  );
};

export default ScrollToTop;
